import { useContext } from "react";
import { Divider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";

function PassengerConfirm({ title, information }) {
    //general variables
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);

    const getPassengerCode = passenger => {
        const { national_code, national_id, passport_no } = passenger;
        const primaryId = national_code || national_id || "";
        const passportNum = passport_no || "";

        return primaryId && passportNum ? `${primaryId} / ${passportNum}` : primaryId || passportNum;
    };

    return (
        <Grid className="confirm" container item xs={12}>
            <Grid className="confirm__title" container item xs={12}>
                {title}
            </Grid>
            <Divider width="100%" />

            {information?.passengers?.length &&
                information?.passengers?.map(passenger => {
                    return (
                        <Grid className="confirm__information" container item xs={12} rowGap={2} justifyContent="space-between">
                            {passenger?.first_name && (
                                <Grid container item xs={12} direction="column">
                                    <span className="confirm__label">{t("name")}</span>
                                    <span className="confirm__value">
                                        {passenger?.first_name} {passenger?.last_name}
                                    </span>
                                </Grid>
                            )}

                            {passenger?.english_first_name && (
                                <Grid container item xs={7} direction="column">
                                    <span className="confirm__label">{t("firstNameEn")}</span>
                                    <span className="confirm__value">
                                        {passenger?.english_first_name} {passenger?.english_last_name}
                                    </span>
                                </Grid>
                            )}

                            {passenger?.gender?.name && (
                                <Grid container item xs={4} direction="column">
                                    <span className="confirm__label">{t("gender")}</span>
                                    <span className="confirm__value">
                                        {locale === "en" ? passenger?.gender?.english_name : passenger?.gender?.name}
                                    </span>
                                </Grid>
                            )}

                            {passenger.nationality && (
                                <Grid container item xs={3.9} direction="column">
                                    <span className="confirm__label">{t("nationality")}</span>
                                    <span className="confirm__value">{passenger?.nationality?.name}</span>
                                </Grid>
                            )}

                            {getPassengerCode (passenger)&& (
                            <Grid container item xs={3.9} direction="column">
                                <span className="confirm__label">
                                    {t("nationalCode")} / {t("passport")}
                                </span>
                                <span className="confirm__value">{getPassengerCode(passenger)}</span>
                            </Grid>
                            )} 

                            {passenger.phone_number && (
                                <Grid container item xs={3.9} direction="column">
                                    <span className="confirm__label">{t("phoneNumber")}</span>
                                    <span className="confirm__value">{passenger?.phone_number}</span>
                                </Grid>
                            )}
                        </Grid>
                    );
                })}
        </Grid>
    );
}

export default PassengerConfirm;
